import dayjs from 'dayjs';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import { getTransactBookReport } from '../../../../../../lib/api/reports';
import DocumentSearcher from '../../../../../../lib/common/DocumentSearcher';
import CenteredCircularProgress from '../../../../../../lib/designSystem/CircularProgress';
import HeaderWithActions from '../../../../../../lib/designSystem/HeaderWithActions';
import TableWithPagination from '../../../../../../lib/designSystem/TableWithPagination';
import confirmingHeaders from './TableHeaders/confirmingHeaders';
import creditHeaders from './TableHeaders/creditHeaders';
import factoringHeaders from './TableHeaders/factoringHeaders';

const TransactBook: React.FC = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();
  const endDateDefault = new Date();
  const [endDate, setEndDate] = useState(dayjs(endDateDefault));
  const startDateDefault = new Date();
  startDateDefault.setDate(startDateDefault.getDate() - 30);
  const [startDate, setStartDate] = useState(dayjs(startDateDefault));
  const [businessIdentifier, setBusinessIdentifier] = useState('');
  const [stakeholderIdentifier, setStakeholderIdentifier] = useState('');
  const [documentType, setDocumentType] = useState('factoring');
  const documentTypes = [
    { label: 'Solicitud de factoring', value: 'factoring' },
    { label: 'Solicitud de crédito', value: 'credit' },
    { label: 'Solicitud de confirming', value: 'confirming' },
  ];
  const [requestId, setRequestId] = useState('');
  const PAGE_SIZE = 10;
  const [pagination, setPagination] = useState({
    page: 0,
    pageSize: PAGE_SIZE,
    total: 0,
    totalPages: 0,
  });
  const generateQuery = ({
    page,
    pageSize,
  }: {
    page: number;
    pageSize: number;
  }) => {
    let query = '';
    if (startDate) query += `startDate=${startDate}&`;
    if (endDate) query += `endDate=${endDate}&`;
    if (requestId) query += `requestId=${requestId}&`;
    if (businessIdentifier)
      query += `businessIdentifier=${businessIdentifier}&`;
    if (stakeholderIdentifier)
      query += `stakeholderIdentifier=${stakeholderIdentifier}&`;
    if (documentType) query += `documentType=${documentType}&`;
    if (page) query += `page=${page}&pageSize=${pageSize}`;
    return query;
  };

  const setUp = async ({
    page,
    pageSize,
  }: {
    page: number;
    pageSize: number;
  }) => {
    setLoading(true);
    const query = generateQuery({ page, pageSize });
    try {
      const response = await getTransactBookReport(dispatch, query);
      setData(response.data);
      setPagination(response.pagination);
    } catch (error) {}
    setLoading(false);
  };
  useEffect(() => {
    setUp({ page: 0, pageSize: PAGE_SIZE });
  }, []);
  if (loading) return <CenteredCircularProgress type="layout" />;
  const dataHeaders =
    documentType === 'factoring'
      ? factoringHeaders
      : documentType === 'credit'
        ? creditHeaders
        : confirmingHeaders;
  return (
    <div>
      <HeaderWithActions
        title="Acá podrás ver todas las solicitudes que se han financiado."
        variant="body1"
        buttons={[
          {
            name: 'Filtro',
            action: () => {},
            color: 'primary',
            customButton: (
              <DocumentSearcher
                requestId={requestId}
                setRequestId={setRequestId}
                documentTypes={documentTypes}
                documentType={documentType}
                setDocumentType={setDocumentType}
                searchData={setUp}
                setData={setData}
                setLoading={setLoading}
                startDate={startDate}
                endDate={endDate}
                setStartDate={setStartDate}
                businessIdentifier={businessIdentifier}
                setBusinessIdentifier={setBusinessIdentifier}
                setEndDate={setEndDate}
                stakeholderIdentifier={stakeholderIdentifier}
                setStakeholderIdentifier={setStakeholderIdentifier}
                pagination={pagination}
              />
            ),
          },
        ]}
      />
      <TableWithPagination
        dataHeaders={dataHeaders}
        data={data}
        actions={[]}
        showActions
        rowsPerPageDefault={100}
        exportToFile="xlsx"
        pagination={pagination}
        setPagination={setPagination}
        setData={setData}
        searchData={setUp}
        lastElement
        finalSumRow={true}
      />
    </div>
  );
};

export default TransactBook;
